/**
 * Motivos de cancelacion de negocio
 * Autor: Benjamín León
 * Fecha: 2024-12-31
 * */

const dealCancelReasonTranslate: Record<string, string> = {
  'REASON.ANOTHER_SHOP': 'Compró en otro lugar',
  'REASON.ERROR.ASK': 'Error al consultar',
  'REASON.CANNOT_CONTACT': 'No es posible comunicarse',
  'REASON.PRICE': 'No se llega a acuerdo de precio',
  'REASON.CREDIT.REJECTED': 'Rechazo de crédito',
  'REASON.VEHICLE.DISAPPOINMENT': 'Vehículo no cumple expectativas',
  'REASON.VEHICLE.SOLD': 'Vehículo vendido',
  'REASON.OTHER': 'Otro',
}
export const transDealCancelReason = (status: string | undefined) => {
  if (!status || status === undefined) {
    status = 'REASON.OTHER'
  }

  return dealCancelReasonTranslate[status]
}
export default dealCancelReasonTranslate
